import { z } from "zod";
import { NonNegativeNumber } from "./commonSchema";

export const StatsPeriodSchema = z.enum([
  "today",
  "last_7_days",
  "last_30_days",
  "this_month",
  "last_month",
  "custom",
]);

export type StatsPeriod = z.infer<typeof StatsPeriodSchema>;

export const StatsSummarySchema = z.object({
  period: StatsPeriodSchema,
  goldBalance: z.coerce.number(),
  pureWeightAdded: NonNegativeNumber,
  inboundPureWeight: NonNegativeNumber,
  totalLabor: NonNegativeNumber,
  totalDeposit: NonNegativeNumber,
  totalCharges: NonNegativeNumber,
  vaultCash: z.coerce.number(),
  cashBalance: z.coerce.number(),
});

export type StatsSummary = z.infer<typeof StatsSummarySchema>;
